import axios from 'axios'
// import { getwaySign } from '@/utils/sign.js'
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000
})

request.interceptors.request.use(
  config => {
    // const sign = getwaySign(config)
    // if (config.url.includes('?')) {
    //   config.url = `${config.url}&${sign}`
    // } else {
    //   config.url = `${config.url}?${sign}`
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
request.interceptors.response.use(
  response => {
    const { data } = response.data
    // if (status === 10000000) {
    return data
    // } else {
    //   return Promise.reject(msg)
    // }
  },
  error => {
    return Promise.reject(error)
  }
)
export { request }
